// @ts-check
/**
 * The errors of the coordination scope.
 *
 * @module classes/coordination/coordination-errors
 * @author Saleh Abdel Motaal <dev@smotaal.io>
 * @ai Claude Fable 5.1 (code generation)
 */

/**
 * This context cannot elect a leader at all.
 *
 * Its own class, because "this browser cannot elect" and "somebody else leads"
 * are different answers and only one of them is news about the origin. A caller
 * that treated the refusal as "I am not the leader" would be right; one that
 * treated it as "so I am the leader" would be guessing, which is the thing the
 * coordinator exists not to do.
 */
export class CoordinationUnavailableError extends Error {
    /** @param {string} [detail] */
    constructor(detail = '') {
        super(
            'This context has no Web Locks (navigator.locks), so no leader can be elected: a lock is what makes '
            + 'exactly one context the leader and what releases leadership when that context dies. Nothing here '
            + 'will guess who leads.' + (detail ? ` ${detail}` : ''));
        this.name = 'CoordinationUnavailableError';
    }
}

/** The coordinator was withdrawn while this was outstanding. */
export class CoordinationClosedError extends Error {
    /** @param {string} what */
    constructor(what) {
        super(`This coordinator was closed, so ${what} was withdrawn with it.`);
        this.name = 'CoordinationClosedError';
    }
}
